export const faqTraditionalData = () => {
  return [
    {
      title: "When will my 2024 tickets be available in my online account?",
      htmlDescription:
        "Tickets will be loaded to your Rays Ticket Account in early 2024, prior to the start of the season.",
    },
    {
      title: "How does auto-renewal work for traditional season members?",
      htmlDescription:
        "All Traditional Season Members are automatically enrolled into auto-renewal where we will automatically renew your Season Membership on an annual basis based on the ten (10) month interest-free payment schedule on your invoice, unless you choose to opt out. There will be a 30 day opt out period beginning in the summer of 2024 for the 2025 season. You will receive an email regarding the 2025 season and the opt out period at that time.",
    },
  ];
};
